import $ from 'jquery';

export function themeChange() {
  if (localStorage.theme) {
    $('body').addClass(localStorage.theme);
  } else {
    $('body').addClass('theme-light');
  }

  if ($('body').hasClass('theme-dark')) {
    $("#change-theme").prop('checked', true);
  } else {
    $("#change-theme").prop('checked', false);
  }

  $("#change-theme").change(function () {
    if ($(this).prop("checked")) {
      $('body').addClass("theme-dark").removeClass("theme-light");
      // $('#change-theme-icon').addClass('pe-icon-moon').removeClass('pe-icon-sun');
      localStorage.theme = 'theme-dark';
    } else {
      $('body').addClass("theme-light").removeClass("theme-dark");
      // $('#change-theme-icon').addClass('pe-icon-sun').removeClass('pe-icon-moon');
      localStorage.theme = 'theme-light';
    }
  });

  $("#change-theme-mobile").change(function () {
    if ($(this).prop("checked")) {
      $("body").addClass("theme-dark").removeClass("theme-light");
      $("#change-theme-icon").text("light_mode"); 
      localStorage.theme = "theme-dark";
    } else {
      $("body").addClass("theme-light").removeClass("theme-dark");
      $("#change-theme-icon").text("dark_mode");
      localStorage.theme = "theme-light";
    }
  });
}